import { useSelector } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

// Registrations are server-paginated newest-first, so the header is display-only.
const rows = [
    { id: 'name', disablePadding: true, label: 'Name' },
    { id: 'email', disablePadding: false, label: 'Email' },
    { id: 'contact', disablePadding: false, label: 'Contact' },
    { id: 'event', disablePadding: false, label: 'Event' },
    { id: 'status', disablePadding: false, label: 'Status' },
    { id: 'payment', disablePadding: false, label: 'Payment' },
    { id: 'date', disablePadding: false, label: 'Registered' },
];

const MatTableHead = () => {
    const rtl = useSelector((state: { rtl: { direction: string } }) => state.rtl);

    return (
        <TableHead>
            <TableRow>
                {rows.map((row) => (
                    <TableCell key={row.id} align={rtl.direction === 'rtl' ? 'right' : 'left'} padding={row.disablePadding ? 'none' : 'normal'}>
                        {row.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default MatTableHead;
